import { colors, fonts, spacing, borderRadius, shadows } from './index';

// Constants
export const ALL_REGION_VALUE = 'ALL';

// Role labels
export const ROLE_LABELS = {
  CH: 'Chairman',
  MP: 'Member Planning',
  ED: 'Executive Director',
  GM: 'General Manager'
};

// Escalation fields by role
export const ESCALATION_FIELDS_BY_ROLE = {
  CH: [
    { role: 'MP', label: 'Select Member Planning', required: true },
  ],
  MP: [
    { role: 'CH', label: 'Select Chairman', required: true },
  ],
  ED: [
    { role: 'MP', label: 'Select Member Planning', required: true },
    { role: 'CH', label: 'Select Chairman', required: true },
  ],
  GM: [
    { role: 'CH', label: 'Select Chairman', required: true },
    { role: 'MP', label: 'Select Member Planning', required: true },
    { role: 'ED', label: 'Select Executive Director', required: true },
  ],
};

// Magic numbers
export const CIRCULAR_PROGRESS_SIZES = {
  LOADING: 28,
  SUBMIT: 20,
};

// Style constants
export const dialogPaperStyles = {
  borderRadius: borderRadius.modal,
  boxShadow: shadows.xl,
  backgroundColor: colors.backgroundWhite,
};

export const dialogTitleStyles = {
  fontSize: fonts.fontSizeLg,
  fontWeight: fonts.weightBold,
  color: colors.textPrimaryDark,
  borderBottom: `1px solid ${colors.borderLight}`,
};

export const dialogContentStyles = {
  pt: spacing.md,
  pb: spacing.sm,
};

export const dialogActionsStyles = {
  borderTop: `1px solid ${colors.borderLight}`,
  px: spacing.md,
  py: spacing.sm,
  display: 'flex',
  justifyContent: 'flex-end',
  gap: spacing.sm,
  backgroundColor: colors.backgroundSoft,
};

export const loadingBoxStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  py: spacing.lg,
};

export const errorBoxStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  py: spacing.lg,
  px: spacing.md,
  gap: spacing.sm,
};

export const errorMessageStyles = {
  color: colors.error,
  fontSize: fonts.fontSizeSm,
  textAlign: 'center',
};

export const errorHelperTextStyles = {
  color: colors.textSecondary,
  fontSize: fonts.fontSizeSm,
  textAlign: 'center',
};

export const emptyStateBoxStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  py: spacing.lg,
  gap: spacing.md,
};

export const emptyStateTextStyles = {
  color: colors.textSecondary,
  fontSize: fonts.fontSizeSm,
};

export const formContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.md,
  mt: spacing.sm,
};

export const getRoleSelectorBoxStyles = (hasError) => ({
  border: `1px solid ${hasError ? colors.error : colors.borderDefault}`,
  borderRadius: borderRadius.input,
  backgroundColor: colors.backgroundWhite,
  px: spacing.sm,
  py: spacing.sm,
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.xs,
});

export const roleSelectorTitleStyles = {
  fontWeight: fonts.weightSemiBold,
  color: colors.textPrimaryDark,
  fontSize: fonts.fontSizeSm,
};

export const radioGroupStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.xs,
};

export const radioStyles = {
  color: colors.textSecondary,
  '&.Mui-checked': {
    color: colors.primary,
  },
};

export const roleLabelStyles = {
  fontSize: fonts.fontSizeSm,
  fontWeight: fonts.weightSemiBold,
  color: colors.textPrimaryDark,
};

export const roleMemberCountStyles = {
  color: colors.textSecondary,
  fontSize: fonts.fontSizeXs,
  mt: '2px',
};

export const errorHelperTextStyles_inline = {
  color: colors.error,
  fontSize: fonts.fontSizeXs,
};

export const noRecipientsTextStyles = {
  color: colors.textSecondary,
  fontSize: fonts.fontSizeXs,
};

export const noRolesTextStyles = {
  color: colors.textSecondary,
  fontSize: fonts.fontSizeXs,
};

export const userSelectFieldStyles = {
  mt: spacing.xs,
  '& .MuiInputLabel-root': {
    display: 'none',
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: borderRadius.input,
    backgroundColor: colors.backgroundWhite,
    minHeight: '48px',
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 0,
    paddingBottom: 0,
  },
};

export const selectPlaceholderStyles = {
  color: colors.textPrimaryDark,
  fontSize: fonts.fontSizeMd,
  fontWeight: fonts.weightNormal,
};

export const cancelButtonStyles = {
  textTransform: 'none',
  borderRadius: borderRadius.button,
  padding: `${spacing.xs} ${spacing.md}`,
  fontSize: fonts.fontSizeSm,
  fontWeight: fonts.weightMedium,
};

export const submitButtonStyles = {
  textTransform: 'none',
  borderRadius: borderRadius.button,
  padding: `${spacing.xs} ${spacing.md}`,
  fontSize: fonts.fontSizeSm,
  fontWeight: fonts.weightSemiBold,
  background: colors.primaryGradient,
  color: `${colors.textWhite} !important`,
  '&:hover': {
    background: colors.primaryGradientHover,
  },
  '&.Mui-disabled': {
    color: `${colors.textWhite} !important`,
  },
};

export const submitSpinnerStyles = {
  color: colors.textWhite,
};
